var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyHouseRules = function SvgHappyHouseRules(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE2E24",
    fillRule: "evenodd",
    d: "M7.989.002a8.14 8.14 0 0 0-5.673 2.435A7.86 7.86 0 0 0 .001 8.139 7.851 7.851 0 0 0 7.867 16h.142a8.073 8.073 0 0 0 7.99-8.138A7.84 7.84 0 0 0 7.99.002zM7 11.029a.98.98 0 0 1 .27-.713.98.98 0 0 1 .696-.307h.018c.547 0 .995.433 1.015.98a.983.983 0 0 1-.966 1.019h-.018A1.02 1.02 0 0 1 7 11.028zm.334-2.695v-4a.666.666 0 1 1 1.333.001v4a.667.667 0 0 1-1.333-.002z"
  })));
};
export default SvgHappyHouseRules;